import { setSubroute } from 'store/navbar'
import { syncStudyModuleViewport } from 'router/viewportWidth'
import InstrumentsViewRoute from './routes/InstrumentsPage'
import InstrumentViewRoute from './routes/Instrument'

// Sync route definition
export default store => {
  return {
    path: 'instruments',
    exact: true,
    indexRoute: InstrumentsViewRoute(store),
    getChildRoutes(location, cb) {
      store.dispatch(setSubroute('instruments'))
      syncStudyModuleViewport(store, location, 'instruments')
      cb(null, [InstrumentViewRoute(store)])
    },
  }
}
